import React, { Component } from "react"
import { connect, getIn } from "formik"
import Input from "react-toolbox/lib/input"
import _ from "lodash"

class FormikInput extends Component {
  props: {
    formik: any,
    name: string,
  }

  render () {
    const inputProps = _.omit( this.props, [ "formik" ] )

    const { name, formik } = this.props
    const error = getIn( formik.errors, name )
    const touched = getIn( formik.touched, name )
    const value = getIn( formik.values, name )

    return (
      <Input
        {...inputProps}
        value={value}
        error={touched && error ? error : undefined}
        onChange={formik.handleChange( name )}
        onBlur={formik.handleBlur( name )}
      />
    )
  }
}

export default connect( FormikInput )



// WEBPACK FOOTER //
// ./src/components/FormikComponents/Input.jsx